import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=1c6cc768&scoped=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=js"
export * from "./BreadCrumb.vue?vue&type=script&lang=js"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=1c6cc768&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6cc768",
  null
  
)

export default component.exports